import { render } from "./AppArticle.vue?vue&type=template&id=3ebe23ac"
import script from "./AppArticle.vue?vue&type=script&lang=js"
export * from "./AppArticle.vue?vue&type=script&lang=js"

import "./AppArticle.vue?vue&type=style&index=0&id=3ebe23ac&lang=scss"

import exportComponent from "/Users/kurlov/WebstormProjects/2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__